export const CUSTOM_VIEW_ACTIVITY_CONFIG = {
    name            : 'Activity stream',
    menuName        : 'Activity',
    icon            : 'i5-activity',
    image           : 'activity',
    iconSvg         : 'isvg-view-activity-stream',
    url             : 'activity',
    stringId        : 'activity',
    description     : 'Activity summary view that shows all related work activity grouped by date, user or project.',
    canBeInProject  : true,
}